export default class Translate {
    constructor($translate, $window, Setting) {
        this.translation = $translate;
        this.window = $window;
        this.settingsRepo = Setting;

        this.availableLanguages = [
            {value: 'sv', text: 'Svenska'},
            {value: 'en', text: 'English'}
        ]
    }

    getAvailableLanguages() {
        return this.availableLanguages;
    };

    translate(key) {
        return this.translation(key)
    };

    useLanguage(key) {
        if (!key || !this.isAvailableLanguage(key)) {
            key = 'en';
        }
        this.window.localStorage.setItem('lang', key);
        this.translation.use(key);
    };

    getDefaultLanguage() {
        return this.settingsRepo.getLanguage();
    };

    setLanguage(key) {
        return this.settingsRepo.setLanguage(key);
    };

    isAvailableLanguage(key) {
        return !!this.availableLanguages.filter(language => language.value === key).length;
    }
}

Translate.$inject = ['$translate', '$window', 'Setting'];
